import React from 'react';
import '../less/credit-limit.less';
import hero_img from '../img/hero_img.png';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import AdditionalProduct from '../../../../../auxiliary-components/shared/AdditionalProductBlock';
import Advantages from '../../../../../auxiliary-components/shared/AdvantagesBlock';
import FilesForDownloadNew from "../../../../../auxiliary-components/shared/FilesForDownloadNew";
import CalculatorNew from '../../../../../auxiliary-components/CalculatorNew';
import advantages_img_1 from '../img/advantages_img_1.png';
import advantages_img_2 from '../img/advantages_img_2.png';
import advantages_img_3 from '../img/advantages_img_3.png';
import { Preloader } from 'MWComponents';
import additionalCards from '../enums/additional_cards_data.json';
import advantagesItemsData from '../enums/advantages_items.json';
import hero_data from '../enums/hero_data.json';

export default function template() {
    const page = 'credit-limit';
    const model = this.getModel();
    
    const imagesMap = {
      advantages_img_1,
      advantages_img_2,
      advantages_img_3
    };

    const advantagesItems = advantagesItemsData.map(item => ({
      ...item,
      img: imagesMap[item.img]
    }));

    return (
        <div className="credit-limit">
          <Hero
            data={hero_data}
            img={hero_img}
            page={page}
          />
          <div className="content">
            <Advantages
              items={advantagesItems}
              title={'CREDIT_LIMIT_NEW_ADVANTAGES_TITLE'}
            />
            {model.creditSum ? (
              <CalculatorNew model={model} type={"limit"} {...this.props}/>
            ) : <Preloader />}
            <AdditionalProduct
              items={additionalCards}
              title={'CREDIT_LIMIT_NEW_ADDITIONAL_PRODUCT_TITLE'}
              page={page}
            />
            <FilesForDownloadNew
              widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
              loader={this.state.loader}
            />
          </div>
        </div>
    );
}
